<app-loader [isLoading]="isLoading"></app-loader>

<div class="header">
    <app-title [title]="title" [subtitle]="subtitle"></app-title>
    <div class="top restaurant">
        <div class="boton">
            <!-- <button class="b1" mat-button routerLink="/home/vacations/drivers/protocol/add">Nuevo protocolo</button> -->
            <button class="b1" mat-button routerLink="/home/vacations/drivers/exercise/add">Nuevo ejercicio</button>
        </div>
    </div>
</div>
<div class="content">

    <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
        <mat-tab label="EJERCICIOS">
            <div class="cards">
                @for(ex of data; track ex.id) {
                <app-exercise-card [exercise]="ex" route="drivers" (statusChanged)="loadExercises()"></app-exercise-card>
                }
            </div>

        </mat-tab>
        <!-- 
        <mat-tab label="NOTIFICACIONES">


        </mat-tab> -->

    </mat-tab-group>

</div>